export default __webpack_public_path__ + "static/media/mono-hombre.dbd91df4.png";